import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Link } from "react-router-dom";
import {BlogCategories} from './../../utils/blog';
import IntroModal from './../introModal';

export default class BlogSideBar extends Component {
  constructor(props) {
      super(props);
  }
  render() {
    return (
      <Fade bottom distance="0%" duration={1500}>
        <div className="tiny-padding">
          <div className="white-background tiny-padding">
            <div className="tiny-padding">
              <h5>{'Categories'}</h5>
            </div>
            <div className="tiny-padding">
              <Link to={'/observations'}>{'All'}</Link>
            </div>
            {BlogCategories && BlogCategories.map((data) =>{
              return(
                <div className="tiny-padding">
                  <Link to={'/observations?category='+data.slug}>{data.name}</Link>
                </div>
              )
            })}
          </div>
        </div>
      </Fade>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/blogSideBar/index.js